import { Container, TextField, Button, AppBar, Modal, Box, Toolbar, Paper, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddSection() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  let navigate = useNavigate();
  const [sectionName, setSectionName] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState('');

  const handleCancel = () => {
    setSectionName("");
  }
  const handleSave = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Section`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          sectionName: sectionName,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();

        setLoadingBarProgress(100);
        
        // Check the status field in the response or error keywords in message
        const errorKeywords = ['already exist', 'failed', 'error', 'unable', 'cannot'];
        const messageHasError = errorKeywords.some(keyword => 
          responseData.msg && responseData.msg.toLowerCase().includes(keyword)
        );
        
        if (responseData.status && responseData.status.toLowerCase().includes('failed')) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else if (messageHasError) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'Section Added Successfully');
        }
        
        setModalOpen(true);
        if (!messageHasError && (!responseData.status || !responseData.status.toLowerCase().includes('failed'))) {
          setSectionName('');
        }
      } else {
        setLoadingBarProgress(0);
        const responseData = await response.json();
        setModalType('error');
        setModalMessage(responseData.msg || 'Failed to save section');
        setModalOpen(true);
      }
    } catch (error) {
      setLoadingBarProgress(0);
      setModalType('error');
      setModalMessage('An error occurred. Please try again later.');
      setModalOpen(true);
    }
  };

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Section
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <div>
          <TextField
            label="Section Name"
            variant="outlined"
            fullWidth
            value={sectionName}
            onChange={(e) => setSectionName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!sectionName && "Enter Section"} arrow>
            <span><Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              sx={{ mr: 2 }}
              disabled={!sectionName}
            >
              SAVE
            </Button></span></Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ 
            backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', 
            padding: '12px 16px' 
          }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1);
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* Snackbar removed - using modal instead */}
    </Container>
  );
}

export default AddSection;
